/*
 * File: DiagnosisCard.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays the diagnosis card in the main post charges form
 */
import React, { useState } from "react";
import { observer } from "mobx-react";
import CloseIcon from "@material-ui/icons/Close";
import Preferences from "services/preferences/Store";
import UIDialog from "components/ui/UIDialog";
import Card from "../Cards";
import DiagnosisHandler from "./DiagnosisHandler";
import DiagnosisList from "./DiagnosisList";
import DiagnosisSearch from "./DiagnosisSearch";
import PropTypes from "prop-types";
import { useStore } from "utils/useStore";

const DiagnosisCard = props => {
  const [formOpen, setFormOpen] = useState(false);
  const preferencesStore = useStore(Preferences);

  const toggleFormOpen = () => {
    setFormOpen(prev => !prev);
  };

  const renderDialog = () => (
    <UIDialog
      noPadding={true}
      fullScreen={true}
      open={formOpen}
      content={() => renderSearch()}
      title="Diagnosis"
      rightNav={() => <CloseIcon onClick={toggleFormOpen} color="inherit" />}
    />
  );

  const renderCardContent = () => (
    <DiagnosisHandler
      store={props.selectedDiagnosesStore}
      render={(items, removeItem) => {
        return (
          <DiagnosisList
            items={items}
            removeItem={removeItem}
            postChargeModel={props.postChargeModel}
          />
        );
      }}
    />
  );

  const renderSearch = () => (
    <DiagnosisSearch
      selectedDiagnosesStore={props.selectedDiagnosesStore}
      parentCallBack={toggleFormOpen}
    />
  );

  const allow = () => {
    return preferencesStore.get("allowDx");
  };

  const renderCard = () => {
    if (!allow()) return "";
    return (
      <Card
        label="Diagnosis"
        addIconOnClick={toggleFormOpen}
        disabled={!props.selectedDiagnosesStore.shouldAllowMoreDiagnoses()}
        content={renderCardContent()}
      />
    );
  };

  return (
    <React.Fragment>
      {renderDialog()}
      {renderCard()}
    </React.Fragment>
  );
};

DiagnosisCard.propTypes = {
  selectedDiagnosesStore: PropTypes.object.isRequired,
  postChargeModel: PropTypes.object.isRequired
};

export default observer(DiagnosisCard);
